import React, { createContext, useContext, useState } from 'react';

// The signed-in user's role in their band: 'owner' | 'admin' | 'performer' (null until known),
// and the band's plan tier. Set by AuthSync from /api/me. They only hide controls; the server
// enforces roles and tiers itself.
const BandContext = createContext({ bandRole: null, setBandRole: () => {}, tier: null, setTier: () => {} });

export function BandProvider({ children }) {
  const [bandRole, setBandRole] = useState(null);
  const [tier, setTier] = useState(null);
  return (
    <BandContext.Provider value={{ bandRole, setBandRole, tier, setTier }}>
      {children}
    </BandContext.Provider>
  );
}

export const useBandRole = () => useContext(BandContext);

// Performers see the band's data but can't change it, so their edit controls are hidden.
// While the role is still loading (null) controls show; the server refuses anything not allowed.
export const useCanEdit = () => useContext(BandContext).bandRole !== 'performer';

// Where the join page keeps an invite token while the user signs in or creates an account
export const PENDING_INVITE_KEY = 'gigrequest:pendingInvite';
